import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { GeoJSON } from 'react-leaflet';
import { onPointsOfInterestClick } from './../../actions/parkingSpots';

import styles from './../../styles/parkingSpots';

class PointsOfInterest extends Component {

  constructor(props) {
    super(props);
    this.onEachFeature = this.onEachFeature.bind(this);
    this.pointsOfInterestStyle = this.pointsOfInterestStyle.bind(this);
  }

  pointsOfInterestStyle(feature) {
    const { FID } = feature.properties;
    const { selectedPointsOfInterest } = this.props;

    if ( selectedPointsOfInterest && (FID === selectedPointsOfInterest.FID) ) {
      // return styles.selectedUnavailableSpot;
      return {
        fillColor: '#eceeef',
        color: '#1f2b3f',
        weight: 1,
        fillOpacity: 1
      };
    }
    // return styles.availableSpot;
    return {
      fillColor: '#ffffff',
      color: '#d0d5d8',
      weight: 1,
      fillOpacity: 1
    };
  }

  onEachFeature(feature, layer) {
    layer.on({
      click: () => {
        this.props.onPointsOfInterestClick(feature.properties);
      }
    });
  }

  render() {
    const {data} = this.props;
    return (
      <GeoJSON key={Math.random()}
               data={data}
               onEachFeature={this.onEachFeature}
               style={this.pointsOfInterestStyle}
               bubblingMouseEvents={false}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const { selectedPointsOfInterest } = state.parkingSpots;
  return {
    selectedPointsOfInterest
  };
};

function mapDispatchToProps(dispatch) {
  return bindActionCreators({onPointsOfInterestClick}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(PointsOfInterest);



// WEBPACK FOOTER //
// ./src/containers/MapLayers/PointsOfInterest.js